export function getColorsScope3(num: number) {

    // Ziel aus 16 Farben sollen die am Weitesten aus einanderliegenden genommen werden
    // num = 2 ---> 0, 15
    // num = 3 ---> 0, 8, 15
    // num = 4 ---> 0, 6, 10, 15
    // num = 5 ---> 0, 4, 8, 11, 15
    // usw.

    if (num < 1 || isNaN(num)) {
        return [];
    }
    const colors = ['#00b050', '#2ab359', '#3fb662', '#4fba6a', '#5dbd7e',
                    '#6ac07c', '#76c384', '#81c58d', '#8cc896', '#97cb9f',
                    '#a1cea7', '#abd0b0', '#b6d3b9', '#bfd6c2', '#c9d8cb',
                    '#d3dbd4'];
    const arr = [];
    const len = colors.length;
    const fact =  len / num;
    arr.push(colors[0]);    // die 1. wird immer verwendet
    for (let i = 1; i < num - 1; i++){
        const idx = Math.floor((i + 0.5)  * fact);
        arr.push(colors[idx]);
        // console.log('IDX: ', idx, fact);
    }
    if (num > 1) {
        arr.push(colors[len - 1]); // die letzte wird immer verwendet
    }

    return arr;
}
